import { formatDateToMMDDYYYY } from '../../../utils/dateUtils';

export const formatRemittanceCurrency = (
  value: string | null | undefined
): string => {
  if (!value) return '—';
  const amount = Number(value);
  if (Number.isNaN(amount)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const formatRemittanceDate = (
  value: string | null | undefined
): string => (value ? formatDateToMMDDYYYY(value) : '—');

/**
 * Render a service period, keeping a one-sided or single-day period honest
 * instead of inventing the missing endpoint.
 *
 * An 835 service line may carry one date or a range, and a partly-filled range
 * would read as a complete one if the absent side were dropped.
 */
export const formatRemittanceDateRange = (
  start: string | null | undefined,
  end: string | null | undefined
): string => {
  const from = start ? formatDateToMMDDYYYY(start) : '';
  const through = end ? formatDateToMMDDYYYY(end) : '';
  if (!from && !through) return '—';
  if (from && through) return from === through ? from : `${from} – ${through}`;
  return from ? `From ${from}` : `Through ${through}`;
};
